import _ from 'lodash';
import querystring from 'querystring';

let _timers = {};

export default class Utils {
  static loadImage(src) {
    return new Promise(resolve => {
      const image = new Image();
      image.onload = () => resolve(image);
      image.src = src;
    });
  }

  static loadImageAll(srcList) {
    const loadStart = async () => {
      const loadList = [];
      _.each(srcList, src => {
        const loader = this.loadImage(src);
        loadList.push(loader);
      });
      await Promise.all(loadList);
    };
    loadStart();
  }

  static wait(duration) {
    return new Promise(resolve => {
      setTimeout(resolve, duration);
    });
  }

  static addTimer({ key, time }, func) {
    this._removeTimer(key);
    _timers[key] = setTimeout(() => {
      this._removeTimer(key);
      func();
    }, time);
  }

  static removeAllTimers() {
    _.each(_timers, (value, key) => {
      this._removeTimer(key);
    });
  }

  static _removeTimer(key) {
    if (_timers[key]) {
      clearTimeout(_timers[key]);
      delete _timers[key];
    }
  }

  static msToSecond(ms) {
    return ms / 60;
  }

  static getZeroPadding(number, length) {
    return `0000000000${number}`.slice(-length);
  }

  static getNumberToList(number) {
    return number.toString().split('');
  }

  static getListToNumber(list) {
    return parseInt(list.join(''));
  }

  static getScrollTop() {
    return document.documentElement.scrollTop || document.body.scrollTop;
  }

  static getOffsetTop(target) {
    const rect = target.getBoundingClientRect();
    return rect.top + Utils.getScrollTop();
  }

  static getArrayRandomIndex(array) {
    return Math.floor(Math.random() * array.length);
  }

  static timing(key, timeFraction) {
    const linear = timeFraction => {
      return timeFraction;
    };
    const quad = timeFraction => {
      return Math.pow(timeFraction, 2);
    };
    const circ = timeFraction => {
      return 1 - Math.sin(Math.acos(timeFraction));
    };
    const back = (x, timeFraction) => {
      return Math.pow(timeFraction, 2) * ((x + 1) * timeFraction - x);
    };

    switch (key) {
      case 'linear':
        return linear(timeFraction);
      case 'quad':
        return quad(timeFraction);
      case 'circ':
        return circ(timeFraction);
      case 'back':
        return back(timeFraction);
    }
  }

  static getTwitterUrl(opts) {
    return `https://twitter.com/share?${querystring.stringify(opts)}`;
  }

  static getFacebookUrl(url) {
    return `https://www.facebook.com/share.php?${querystring.stringify({
      u: url
    })}`;
  }

  static getLineUrl(text, url) {
    const params = encodeURIComponent([text || '', url || ''].join('\n'));
    return `http://line.me/R/msg/text/?${params}`;
  }

  static getUniqueID() {
    const strong = 1000;
    return (
      new Date().getTime().toString(16) +
      Math.floor(strong * Math.random()).toString(16)
    );
  }

  static tracking(action) {
    gtag('event', action, {
      label: 'hashire-turn-ouji',
      value: '1'
    });
  }
}
